import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fd7dee5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recoverMessage__wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "circleWithCheck",
  style: {"margin-bottom":"16px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkSymbol" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "authForm__p" }, "Your new password has been set", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "authForm__p" }, "You can now use it to log in", -1))

import { OverlayLayout, Button } from '@/v2/shared/ui/';
import { useRouter } from 'vue-router';
import { h } from 'vue';
import { LoadingOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewPasswordOverlays',
  props: {
  showSuccess: {
    type: Boolean,
    required: false,
  },
  loading:{
    type: Boolean,
    required: false,
  },
},
  setup(__props) {


const router = useRouter();

const indicator = h(LoadingOutlined, {
  style: {
    fontSize: '24px',
  },
  spin: true,
});

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showSuccess)
      ? (_openBlock(), _createBlock(_unref(OverlayLayout), {
          key: 0,
          style: {"border-radius":"9px","background-color":"var(--color-white)"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _createVNode(_unref(Button), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('auth')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Go to login form")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.loading)
      ? (_openBlock(), _createBlock(_unref(OverlayLayout), {
          key: 1,
          style: {"border-radius":"9px","background-color":"var(--color-white)","opacity":"0.5"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_spin, { indicator: _unref(indicator) }, null, 8, ["indicator"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})